import { IMQTTBrokerSettings } from "contexts/HMICachedDataContext/HMICachedDataContextInterfaces";
import { IMachineCenter } from "contexts/HMICachedDataContext/HMICachedDataContextInterfaces";
import { IClusterMachineCenter } from "contexts/ClusterCachedDataContext/ClusterCachedDataContextInterfaces";

export enum HeartbeatMode {
    SINGLE = "single",
    CLUSTER = "cluster",
}

export interface ISingleHeartbeatMessage {
    name: string;
    id: number;
    plcAddress: string | null;
    timestamp: string;
    version: string;
}

export interface IClusterHeartbeatMessage {
    clusterName: string;
    timestamp: string;
    version: string;
    machineCenters: Array<{
        name: string;
        id: number;
        plcAddress: string | null;
    }>;
}

export interface IUseHMIHeartbeatSignalProps {
    mode: HeartbeatMode;
    machineCenter?: IMachineCenter;
    machineCenters?: IClusterMachineCenter[];
    clusterId?: number;
    clusterName?: string;
    mqttBrokerSettings?: IMQTTBrokerSettings;
    enabled: boolean;
}
